<script setup lang="ts">
onErrorCaptured((error) => {
  showSnackbar({ variant: 'error', title: error.name, description: error.message });
  return false;
});

useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} - Sellebrate` : 'Sellebrate';
  },
});

// Onboarding wizard logic
const authStore = useAuthStore();
const { isAuthenticated } = storeToRefs(authStore);

// One-time user hydration on client start
const userStore = useUserStore();
const { user } = storeToRefs(userStore);

onMounted(async () => {
  // Refresh user to see if company has been created
  if (isAuthenticated.value && (!user.value || user.value.companyId === null)) {
    await userStore.fetchMe();
  }
});
</script>

<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>

  <!-- Shared elements across the application that can be shown at any given point -->
  <ClientOnly>
    <SBModalConfirm />
    <SBModalChatLimitWarning v-if="isAuthenticated" />
    <SBSnackbarContainer />
  </ClientOnly>
</template>
